import { cn } from "@/lib/utils";

interface CornPatternBackgroundProps {
  className?: string;
  /** Color de relleno (usar con alpha bajo, rgba o hex) */
  color?: string;
  /** Separación de cuadrícula en px */
  gap?: number;
  /** Separación horizontal en px */
  gapX?: number;
  /** Separación vertical en px */
  gapY?: number;
  /** Altura del ícono de choclo en px */
  size?: number;
}

const SVG_PATH =
  "M2.98482 124.622C8.89056 126.38 28.7329 137.263 34.3989 140.469C59.3428 154.586 80.5427 183.383 90.5896 209.937C93.1866 216.792 96.1749 229.826 98.0644 237.381C106.047 187.552 148.232 144.688 195.336 129.423C195.761 165.477 198 193.543 180.37 226.808C177.199 232.783 161.101 263.384 153.101 259.638C152.227 256.412 153.16 255.128 154.084 251.6C161.617 225.044 161.35 225.69 160.926 198.014C132.625 210.253 117.95 232.933 106.804 260.867C104.723 266.086 100.287 279.208 97.3069 282.807L95.8919 282.892C94.8348 280.92 90.265 263 89.0497 259.355C78.833 228.691 64.3962 206.562 35.1638 191.746C34.0759 220.927 35.4443 226.396 42.3173 253.984C21.1482 237.525 9.19272 214.525 4.08606 188.538C0.768186 171.655 -2.60379 141.092 2.98482 124.622ZM98.9696 0C108.565 6.41537 119.895 27.6888 124.369 38.5104C140.09 76.5461 140.597 119.058 126.129 157.569C125.075 160.377 121.422 170.237 119.148 171.235C110.715 166.383 120.617 152.191 120.36 144.92C119.688 125.649 113.031 97.4222 100.995 82.4095L99.3597 82.5753C88.4695 102.651 81.6299 134.073 84.8837 156.688C85.5809 161.542 89.1418 174.954 89.1335 177.834C87.5315 178.057 86.6434 178.111 85.2904 176.888C65.3768 158.898 66.3512 126.019 65.2556 102.73C63.2319 59.7077 76.4861 34.2436 98.9696 0Z";

/**
 * Patrón ornamental estático con el isotipo de choclo (corn.svg).
 */
export function CornPatternBackground({
  className,
  color = "rgba(150, 150, 150, 0.18)",
  gap = 60,
  gapX,
  gapY,
  size = 14,
}: CornPatternBackgroundProps) {
  const gx = gapX ?? gap;
  const gy = gapY ?? gap;
  const scale = size / 283;
  const w = 196 * scale;
  const h = 283 * scale;
  const offsetX = (gx - w) / 2;
  const offsetY = (gy - h) / 2;

  const svgString = `<svg xmlns='http://www.w3.org/2000/svg' width='${gx}' height='${gy}' viewBox='0 0 ${gx} ${gy}'><g transform='translate(${offsetX.toFixed(2)}, ${offsetY.toFixed(2)}) scale(${scale.toFixed(4)})' fill='${color}'><path d='${SVG_PATH}'/></g></svg>`;

  const encodedSvg = encodeURIComponent(svgString);

  return (
    <div
      aria-hidden="true"
      className={cn("pointer-events-none absolute inset-0", className)}
      style={{
        backgroundImage: `url("data:image/svg+xml,${encodedSvg}")`,
        backgroundRepeat: "repeat",
        backgroundSize: `${gx}px ${gy}px`,
      }}
    />
  );
}
